import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter, Input } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Subscription } from "rxjs";

import datatableMessages from "../../../assets/datatables/table-messages.json";
import { FiltroUsuarios } from "../../../shared/Entities/Filtro/filtroUsuario.entity";
import { Perfil } from "../../../shared/Entities/Perfil/perfil.entity";
import { Rol } from "../../../shared/Entities/Rol/rol.entity";
import { Usuario } from "../../../shared/Entities/Usuario/usuario.entity";
import { PerfilRepository } from "../../../shared/Repositories/perfil.repository";
import { RolesRepository } from "../../../shared/Repositories/roles.repository";
import { UsuariosRepository } from "../../../shared/Repositories/usuarios.repository";

@Component({
  selector: "filtro-tabla",
  templateUrl: "./filtro.component.html",
  styleUrls: ["./filtro.component.scss"],
})
export class FiltroTablaComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public currentUser: Usuario;

  public selectedProperty: any;
  @Input() public showForm: boolean;
  @Input() public hideProfile: boolean;

  public filterProperties = [
    {
      text: "Nombre y Apellido",
      value: "nombres",
      active: false,
    },
    {
      text: "Rango de Fecha",
      value: "desde",
      active: false,
    },
    {
      text: "Identificación",
      value: "identificacion",
      active: false,
    },
    {
      text: "Estado",
      value: "activo",
      active: false,
    },
    {
      text: "Perfil",
      value: "perfil",
      active: false,
    },
    {
      text: "Rol",
      value: "rol",
      active: false,
    },
    {
      text: "Codigo de Usuario",
      value: "userCode",
      active: false,
    },
  ];

  public tempFilter = {};
  public saveFilter: FiltroUsuarios;

  public perfiles: Perfil[];
  public roles: Rol[];

  public datatableMessages = datatableMessages;

  public filterAttempted = false;
  public filtersActive = false;

  @ViewChild("tempFilterTabla", { static: false }) public tempFilterTabla: NgForm;
  @Output() public searchClicked: EventEmitter<any> = new EventEmitter();

  constructor(
    private usuarioRepository: UsuariosRepository,
    private perfilRepository: PerfilRepository,
    private roleRepository: RolesRepository
  ) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.usuarioRepository.getInfoClienteActual().subscribe((currentUser) => {
        this.currentUser = currentUser;
      })
    );

    this.selectedProperty = this.filterProperties[0];
    this.saveFilter = new FiltroUsuarios();

    if (this.hideProfile) {
      this.filterProperties = this.filterProperties.filter((property) => {
        return property.value !== "perfil";
      });
    } else {
      this.getPerfiles();
    }
    this.getRoles();
  }

  public onFilterAdded(): void {
    this.filterAttempted = true;
    if (this.tempFilterTabla.valid) {
      this.selectedProperty.active = true;
      Object.assign(this.saveFilter, this.tempFilter);
      this.tempFilter = {};
      this.selectedProperty = this.filterProperties.find((property) => {
        return property.active === false;
      });
      this.filterAttempted = false;
      this.filtersActive = this.checkFiltersActive();
    }
  }

  public onFilterRemoved(...args: any[]): void {
    args.forEach((arg) => {
      this.saveFilter[arg] = undefined;

      const property = this.filterProperties.find((_property) => {
        return _property.value === arg;
      });
      if (property) property.active = false;
    });
    this.filtersActive = this.checkFiltersActive();
  }

  public onSearchClicked(): void {
    this.searchClicked.emit(this.saveFilter);
  }

  public onPropertyChanged(): void {
    this.filterAttempted = false;
  }

  public checkFiltersActive(): boolean {
    let filtersActive = false;
    for (const prop in this.saveFilter) {
      if (this.saveFilter[prop]) filtersActive = true;
    }
    return filtersActive;
  }

  public getPerfiles(): void {
    this.perfilRepository.getPerfiles().subscribe((perfiles) => {
      this.perfiles = perfiles;
    });
  }

  public getRoles(): void {
    this.roleRepository.getRoles().subscribe((roles) => {
      this.roles = roles;
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) subscription.unsubscribe();
    });
  }
}
